module.exports = flarum.core.compat['components/DiscussionHero'];